import * as React from 'react';
import {BadgeProps} from '../types/common';
import {ChildrenProps} from '../../admin/commissions/common/types/components';

const Badge: React.FC<BadgeProps & ChildrenProps> = ({badgeStyle, labelStyle, lineBadgeStyle, currentStep, label, children}) => {
    const txtStyle: string = `ml-3 ${labelStyle}`;
    return (
        <React.Fragment>
            <div className={lineBadgeStyle}>
                <div className="d-flex justify-content-start">
                    <span className={badgeStyle}>{currentStep}</span>
                    <p className={txtStyle}>{label}</p>
                </div>
                {children}
            </div>
        </React.Fragment>
    );
};

export default Badge;
